export default {"src":"/_next/static/media/Diabetic_Condition.2a26753c.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};